export const liveBlogPopout = () => {

  const blogPage = document.querySelector('.live-blog');
  const popout = document.querySelector('.live-blog-popout');

  if(!popout || blogPage) return;

  popout.classList.add('visible');

};